export default (function (value) {
  return value === null || value === undefined;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isNil.js
// module id = 1003
// module chunks = 2